// @ts-nocheck
import bunzlReducer, { BunzlActions } from "@store/Framework/Store/Bunzl/BunzlReducer";
import foundationReducer, { FoundationActions } from "@store/Framework/Store/Foundation/FoundationReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import "@store/Framework/Store";

/* Store Custom Code - Start */
import storeReducer, { StoreActions } from "@store/Framework/Store/Store/StoreReducer";
/* Store Custom Code - End */

export type BunzlAnyAction = BunzlActions;
export type FoundationAnyAction = FoundationActions;

(reducers as any).bunzl = bunzlReducer;
(reducers as any).foundation = foundationReducer;

/* Store Custom Code - Start */
export type StoreAnyAction = StoreActions;

(reducers as any).store = storeReducer;
/* Store Custom Code - End */
